<template>
  <div class="foot">
    <div class="top">
        <div class="left">
            <div class="logo">
                <img src="@/assets/images/atenCamera/logo.png" alt="">
            </div>
            <div>
                <div>邮箱:{{ email }}</div>
                <div>地址：{{ add }}</div>
            </div>
        </div>
    <div class="tel">
        <div class="title">合作咨询</div>
        <!-- <div>025-86129993</div> -->
        <div>138 5140 8423</div>
        <div>138 5140 9680</div>
    </div>
    <div class="navbar">
        <div class="title">快速导航</div>
        <ul>
            <li><a href="/">首页</a></li>
            <li><a href="/products">方案</a></li>
            <li><a href="/CustomerCase">客户案例</a></li>
            <li><a href="/NewsLists">公司资讯</a></li>
            <li><a href="/aboutUs">关于我们</a></li>
            <li><a href="/Contact">联系我们</a></li>
        </ul>
    </div>
    <div class="right">
        <div class="title">总裁办24H投诉电话</div>
        <div class="tel">159 5166 2710</div>
        <div class="code">
            <div><img src="@/assets/images/atenCamera/qrCode.png" alt=""> <p>关注我们</p></div>
            <div><img src="@/assets/images/atenCamera/code.png" alt=""> <p>业务咨询</p></div>
        </div>
    </div>
    </div>
    <div class="bottom">{{botton}} <a href="https://beian.miit.gov.cn/" target="_black" >{{Icp}}</a></div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      email: "biz@bridgetek.cn",
      add: "南京市雨花台区花神大道90号中兴物联研发大楼2号楼",
      botton: "Copyright©2016 步锐捷电子科技有限公司",
      Icp: " 苏ICP备15008024号-2"
    };
  }
};
</script>

<style scoped>
* {
    box-sizing: border-box;
}
.foot {
  width: 100%;
  height: 343px;
  color: #fff;
  font-size: 14px;
  background-color: #1D2A46;
  padding-top:35px ;
}

.top {
    height: calc(100% - 25px);
  width: auto;
  font-size: 14px;
  display: flex;
  justify-content: space-evenly;
}
.left .logo{
    margin-bottom:6px;
    /* display: flex;
    flex-direction: column;
    justify-content: space-between; */
}
.top div {
    margin-bottom: 20px;
}

.title {
    font-size: 16px;
    font-weight: 600;
}
.right {
    width: 250px;
}

.right .title {
    height: 40px;
    border-bottom:1px solid rgba(255,255,255,.5);
}

.right .tel {
    font-size: 30px;
    font-weight: 600;
}


.code {
    display: flex;
    justify-content: space-between;
}
.code p {
    margin-top: 12px;
    text-align: center;
}
a {
  text-decoration: none;
  color: #fff;
}

li {
  list-style: none;
  margin-bottom: 16px;
}

.bottom {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue